// extracted by mini-css-extract-plugin
module.exports = {"listItem":"Card_listItem__2cC9v","cardItem":"Card_cardItem__3V5Gd","spanClass":"Card_spanClass__nrhu7","faicons":"Card_faicons__2m8FF"};